export default __webpack_public_path__ + "static/media/5.66f8cbe2.jpg";